module.exports = __webpack_public_path__ + "media/images/sp/specials/common/event_detail_photo_experience-18099cd5dc588ec6c872cc6440177359.jpg";